var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#338a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "339b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#339b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0091E",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0033AB",
    fillRule: "evenodd",
    d: "M0 0h22v8.533H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0v16.035L10.476 8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDD200",
    fillRule: "evenodd",
    d: "M4.699 8.518C5.61 8.459 6.286 8.25 6.286 8s-.676-.46-1.587-.518c-.058-.928-.262-1.616-.509-1.616-.245 0-.45.688-.508 1.616-.911.059-1.587.267-1.587.518 0 .25.676.458 1.587.517.057.928.262 1.616.508 1.616s.45-.688.509-1.616",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDD200",
    d: "M7.857 8.532c.29 0 .524-.24.524-.534a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.534.524.534M2.619 5.332c.29 0 .524-.238.524-.533a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.533.524.533M2.619 11.735c.29 0 .524-.24.524-.534a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.534.524.534"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "338a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagPh = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagPh);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";